<div class="condensed-full-header-wrapper">
  <div class="detailview-image">
    <div class="image-border" miq-bg-image [imageSrc]="primaryImageField?.sanitized_media_path"></div>
  </div>
  @if (additionalImages) {
    <div>
      @if (!hasAdditionalImage) {
        <div class="additional-image-section">
          <button class="additional-image-btn" (click)="addAdditionalImage('add')">
            <mat-icon svgIcon="add-icon"></mat-icon>
            <span>{{ 'template.additionalImage' | translate }}</span>
          </button>
        </div>
      } @else {
        <div class="detailview-image additional_image">
          <div class="actions">
            <mat-icon svgIcon="edit-icon" (click)="addAdditionalImage('edit')"></mat-icon>
            <mat-icon svgIcon="delete" (click)="deleteImage(0)"></mat-icon>
          </div>
          <div class="image-border" miq-bg-image [imageSrc]="additionalImageField?.sanitized_media_path"></div>
        </div>
      }
    </div>
  }
</div>
